import "./Display.css";
import React from "react";

interface DisplayProps
{
    children?: React.ReactNode;
    header?: string;
    value?: string;
    footer?: string | null;
    className?: string;
}

export default class Display extends React.Component<DisplayProps>
{
    render()
    {
        return (
            <div className={this.props.className + " display"}>
                <div className="header">{this.props.header}</div>
                <div className="contentContainer">
                    {this.props.children}
                </div>
                <div className="footer">{this.props.footer}</div>
            </div>
        );
    }
}

export class Display2 extends React.Component<DisplayProps>
{
    render()
    {
        return (
            <div className={this.props.className + " display2"}>
                <div className="display2-header">{this.props.header}</div>
                <div className="display2-content">
                    {this.props.children}
                </div>
            </div>
        );
    }
}